import { createAction } from '@reduxjs/toolkit';

import { loginReducerTypes } from 'types/store/auth/login';

export const AUTH_LOGIN_SAGA = 'AUTH_LOGIN_SAGA';
export const loginSaga = createAction<loginReducerTypes.ILoginForm>(AUTH_LOGIN_SAGA);
